import { useState, useEffect, useContext } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import useSort from '../../../hooks/useSort';
import Filter from '../../Filter';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SnackBar from 'components/SnackBar';
import globalTranslating from '../../../translate.json';
import ProfauctsTranslate from '../translate.json';
import GlobalContext from '../../../contexts';
import Api from 'utils/api';
import usePostData from 'hooks/usePostData';

const ProductsList = () => {
  const navigate = useNavigate();
  const translating = { ...globalTranslating, ...ProfauctsTranslate };
  const { organizationsList, setLink } = useContext(GlobalContext);
  const { res: productsData } = usePostData('product/get_products');
  const [filteredProducts, setFilteredProducts] = useState();
  const { showFilters, toggle } = useSort();
  const [searchParams] = useSearchParams();
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    const isAdded = searchParams.get('added');
    if (isAdded) {
      setShowSnakbar(true);
      searchParams.delete('added');
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}${window.location.pathname}`
      );
    }
  }, []);

  useEffect(() => {
    if (productsData?.length) setFilteredProducts(productsData);
  }, [productsData]);

  const onFilter = (filteredData) => {
    setFilteredProducts(filteredData);
  };

  const onResetFilters = () => {
    setFilteredProducts(productsData);
  };

  const tableHeaders = [
    translating.productCode,
    translating.productName,
    translating.productPrice,
    translating.orgRelated,
    translating.dateCreated,
    translating.sales,
    translating.costs,
    translating.status
  ];

  const columns = [
    { value: 'id', bold: true },
    { value: 'name' },
    { value: 'price', format: 'price' },
    { value: 'organizationName' },
    { value: 'createdAt', format: 'date' },
    { value: 'cnt' },
    { value: 'total_price' },
    { value: 'isActive', sort: true, format: 'status' }
  ];

  const actionsOrgsList = [
    {
      icon: SortIcon,
      bottom: true,
      txt: 'עריכה',
      handleClickAction: () => {
        showFilters && setFilteredProducts(productsData);
        toggle(!showFilters);
      }
    }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['name']
    },
    {
      type: 'date',
      subType: 'fromDate',
      label: translating.fromDate,
      name: 'fromDate',
      field: 'startDate'
    },
    {
      type: 'date',
      subType: 'toDate',
      label: translating.toDate,
      name: 'toDate',
      field: 'endDate'
    },
    {
      type: 'select',
      label: translating.status,
      name: 'isActive',
      options: [
        { id: 1, name: 'פעיל' },
        { id: 0, name: 'חסום' }
      ],
      isId: true
    },
    {
      type: 'select',
      label: translating.orgRelated,
      name: 'organizationId',
      options: organizationsList,
      isId: true
    }
  ];

  const handleServerFilter = async (filters) => {
    return await Api.post('product/get_products', filters);
  };

  return (
    <div className="produscts-list">
      <ListHeader
        title={translating.productsListTitle}
        actions={actionsOrgsList}
        newItem={{ handleClick: () => setLink('add') }}
      ></ListHeader>
      {showFilters && (
        <Filter
          fields={sortFields}
          data={productsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
          ssf={handleServerFilter}
        ></Filter>
      )}
      <div className="products-list-wrapper-table">
        <TablePagination
          headers={tableHeaders}
          columns={columns}
          rows={filteredProducts}
          pagination={true}
          handleRowClick={(id) => {
            navigate(`/products/${id}`);
          }}
        ></TablePagination>
      </div>
      {showSnackbar && (
        <SnackBar
          msg={'מוצר נוסף'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default ProductsList;
